import { ETopic } from '../../../types/topic';
export function prepareOffer(formValue) {
  switch (formValue.topic) {
    case ETopic.OfferComplaint:
    case ETopic.ComplaintFromOwnerProperty:
    case ETopic.ComplaintFromOwnerPhoto:
      return formValue.ownerOfferLink;
  }
  return undefined;
}